import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M21.375 15C21.375 15.2984 21.2565 15.5845 21.0455 15.7955C20.8345 16.0065 20.5484 16.125 20.25 16.125H3.75C3.45163 16.125 3.16548 16.0065 2.9545 15.7955C2.74353 15.5845 2.625 15.2984 2.625 15C2.625 14.7016 2.74353 14.4155 2.9545 14.2045C3.16548 13.9935 3.45163 13.875 3.75 13.875H20.25C20.5484 13.875 20.8345 13.9935 21.0455 14.2045C21.2565 14.4155 21.375 14.7016 21.375 15ZM3.75 10.125H20.25C20.5484 10.125 20.8345 10.0065 21.0455 9.7955C21.2565 9.58452 21.375 9.29837 21.375 9C21.375 8.70163 21.2565 8.41548 21.0455 8.2045C20.8345 7.99353 20.5484 7.875 20.25 7.875H3.75C3.45163 7.875 3.16548 7.99353 2.9545 8.2045C2.74353 8.41548 2.625 8.70163 2.625 9C2.625 9.29837 2.74353 9.58452 2.9545 9.7955C3.16548 10.0065 3.45163 10.125 3.75 10.125Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconMenu'

export const IconMenu = memo(themed(Icon))
